import React, { useContext } from 'react';
import { DataGrid } from '../../../../../components/DataGrid/DataGrid';
import { localText } from '../../../../../langs/fa/data-grid';
import { store as mainStore } from '../../../../../store';
import { store } from './reducer';

const Lists = () => {
  const {
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    state: { inProgress, cities },
    dispatch,
  } = useContext(store);
  const columns = [
    {
      field: 'title',
      headerName: 'نام شهر',
      width: 150,
    },
    {
      field: 'state',
      headerName: 'استان',
      width: 150,
    },
    {
      field: 'mostUse',
      headerName: 'پرتردد',
      width: 100,
    },
    {
      field: 'isDestinationOnly',
      headerName: 'مبدا بارگیری',
      width: 150,
    },
    { field: 'priceCalculationType', headerName: 'شیوه محاسبه', width: 150 },
    { field: 'fleet', headerName: 'ناوگان آزاد', flex: 1 },
  ];
  const priceCalculationType = {
    formula: 'سیستمی',
    default: 'فایل اکسل',
    bycustomer: 'صاحب‌بار',
  };

  const handleSelect = ({ row, field }) => {
    const { id } = row;
    dispatch({ type: 'SELECT_CITY', payload: id });
  };
  const handlePageChange = ({ page }) => {
    dispatch({ type: 'PAGE', payload: page });
  };

  return (
    <div style={{ width: '100%', height: 600 }}>
      <DataGrid
        rows={
          cities?.docs?.map((city) => ({
            id: city._id,
            title: city.title,
            state: city.state.title,
            mostUse: city?.mostUse ? 'بله' : 'خیر',
            isDestinationOnly: city?.isDestinationOnly ? 'خیر' : 'بله',
            priceCalculationType: city?.priceCalculationType
              ? priceCalculationType[city.priceCalculationType]
              : 'نامشخص',
            fleet:city?.fleet?.map(f=>f.title)?.join('،') || '-'
          })) || []
        }
        columns={columns}
        localeText={localText}
        pageSize={itemsCountPerPage}
        rowCount={cities?.totalDocs || 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={inProgress}
        disableMultipleSelection
        onCellClick={handleSelect}
        density="compact"
      />
    </div>
  );
};

export default React.memo(Lists);
